import { Component } from '@angular/core';
import { NavController } from 'ionic-angular';
import { Events } from 'ionic-angular';

@Component({
  selector: 'page-newBottler',
  templateUrl: 'newBottler.html'
})

export class NewBottlerPage {

  items: string[];
  newName: string = "";

  constructor(public navCtrl: NavController, public events: Events) {
  }

  saveBottler(event) {
    console.log("Save Bottler: " + this.newName);

      if(this.newName.length > 0)
      {
        console.log("Sending bottlers:add event");
        this.events.publish("bottlers:add", this.newName);
      }
  }
}




// WEBPACK FOOTER //
// ./src/pages/newBottler/newBottler.ts